import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/feed-back';
import { isPhoneNO } from '@polyv/utils/src/validate';
import { BEFORE_DESTROY } from '@/assets/utils/compat';
export default {
  langs,

  mixins: [entryMixin],

  props: {
    isShowFeedBack: {
      type: Boolean
    },
    feedBackSdk: {
      type: Object,
      default: null,
    },
    // 提示语的自定义 classname
    tipsClass: {
      type: String,
      default: '',
    },
    mountNode: {
      type: String
    }
  },

  data() {
    return {
      selValue: '', // 投诉类型
      selectData: [], // 投诉类型数据
      classValue: '', // 反馈类型
      selectClassData: [],
      suggestionData: [], // 反馈类型数据
      complaintData: [], // 投诉类型数据
      feedBackContent: '', // 反馈的额外内容
      captchaValue: '', // 验证码
      contact: '', // 联系方式
      captchaObj: {}, // 生成的验证码对象（地址，ID）
      btnIsChenked: true,
      files: null, // 上传的文件
      showalertInfo: false,
      showalertText: '',
      isScrollBottom: false, // 是否滚动到元素底部
    };
  },
  beforeMount() {
    // 初始化下拉框
    this.selValue = 'complaint';
    this.initOptions();
    this.initFeedbackData();
    this.initComplaintData();
    this.selectClassData = this.complaintData;
  },
  computed: {
    isDisabled() {
      return !(this.selValue && this.classValue && this.captchaValue && this.btnIsChenked);
    }
  },

  watch: {
    isShowFeedBack: {
      immediate: true,
      handler(val) {
        if (val) {
          this.btnIsChenked = true;
          this.resetFrom();
          this.onGetcode();
        }
      },
    },
    feedBackSdk: {
      immediate: true,
      handler() {
        this.bindAppEvents();
      },
    },
    _useLang() {
      this.initOptions();
      this.initFeedbackData();
      this.initComplaintData();
      if (this.selValue === 'suggestion') {
        this.selectClassData = this.suggestionData;
      } else {
        this.selectClassData = this.complaintData;
      }
    },
    captchaValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.captchaValue = newVal.replace(/[^\w./]/ig, '');
      }
    }
  },

  [BEFORE_DESTROY]() {
    this.unbindAppEvents();
  },

  methods: {
    _getCoreSdk() {
      return this.feedBackSdk;
    },
    getScroll(event) {
      // 滚动条距离底部的距离scrollBottom
      const scrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
      if (scrollBottom <= 0) {
        this.isScrollBottom = true;
      } else {
        this.isScrollBottom = false;
      }
    },
    initOptions() { // 初始化投诉类型select选项中英文 文案
      this.selectData = [
        {
          name: this.iarTrans('feedBack.feedTypeOption2'),
          value: 'complaint'
        },
        {
          name: this.iarTrans('feedBack.feedTypeOption1'),
          value: 'suggestion'
        },
      ];
    },
    initFeedbackData() { // 初始所属分类-意见反馈，中英文 文案
      this.suggestionData = [
        {
          name: this.iarTrans('feedBack.stuck'),
          value: 'stuck'
        },
        {
          name: this.iarTrans('feedBack.blackScreen'),
          value: 'black-screen'
        },
        {
          name: this.iarTrans('feedBack.slowAccess'),
          value: 'slow-access'
        },
        {
          name: this.iarTrans('feedBack.poorExperience'),
          value: 'poor-experience'
        },
        {
          name: this.iarTrans('feedBack.playSuggestion'),
          value: 'play-suggestion'
        },
        {
          name: this.iarTrans('feedBack.otherFeedback'),
          value: 'other-feedback'
        },
      ];
    },
    initComplaintData() { // 初始所属分类-投诉，中英文 文案
      this.complaintData = [
        {
          name: this.iarTrans('feedBack.porn'),
          value: 'porn'
        },
        {
          name: this.iarTrans('feedBack.uncivilized'),
          value: 'uncivilized'
        },
        {
          name: this.iarTrans('feedBack.illegalEntry'),
          value: 'illegal-entry'
        },
        {
          name: this.iarTrans('feedBack.bloody'),
          value: 'bloody'
        },
        {
          name: this.iarTrans('feedBack.scam'),
          value: 'scam'
        },
        {
          name: this.iarTrans('feedBack.infringeRight'),
          value: 'infringe-right'
        },
        {
          name: this.iarTrans('feedBack.otherViolations'),
          value: 'other-violations'
        },
      ];
    },
    getValue(name, value) { // 获取select 投诉类型的值
      if (value !== this.selValue) {
        this.classValue = '';
      }
      this.selValue = value;
      if (value === 'suggestion') {
        this.selectClassData = this.suggestionData;
      } else {
        this.initComplaintData();
        this.selectClassData = this.complaintData;
      }
    },
    getClassValue(name, value) {
      this.classValue = value;
    },
    resetFrom() { // 重置表单数据
      this.initOptions();
      this.initFeedbackData();
      this.selectClassData = this.complaintData;
      this.selValue = 'complaint';
      this.classValue = '';
      this.feedBackContent = '';
      this.contact = '';
      this.captchaValue = '';
      if (this.$refs.uploaderDom) {
        this.$refs.uploaderDom.files = [];
      }
      this.files = null;
    },
    bindAppEvents() {
      const feedBackSdk = this.feedBackSdk;
      if (!feedBackSdk) { return; }
      feedBackSdk.on(feedBackSdk.events.SUBMIT, this.onSubmit);
    },

    unbindAppEvents() {
      const feedBackSdk = this.feedBackSdk;
      if (!feedBackSdk) { return; }
      feedBackSdk.off(feedBackSdk.events.SUBMIT, this.onSubmit);
    },
    getFile(file) {
      file && file.length >= 1 ? this.files = file : this.files = null;
    },
    doesFiles() { // 取.file才是真正的文件
      if (this.files && this.files.length >= 1) {
        return this.files.map(item => item.file);
      } else {
        return '';
      }
    },
    async feedBackHand() { // 提交反馈
      if (this.contact !== '' && !isPhoneNO(this.contact)) {
        // 输入框聚焦
        this.$refs?.phoneRef.focus();
        this.showalertText = this.iarTrans('feedBack.errorPhone');
        this.showalertInfo = true;
        return;
      }
      this.btnIsChenked = false;
      const obj = {
        type: this.selValue,
        label: this.classValue,
        content: this.feedBackContent,
        captchaId: this.captchaObj.captchaId,
        captchaValue: this.captchaValue,
        contact: this.contact,
        imageFiles: this.doesFiles()
      };
      let data;
      try {
        data = await this.feedBackSdk.feedbackSave(obj);
      } catch (e) {
        this.btnIsChenked = true;
        // 提示 接口返回的错误信息或接口超时。
        this.showalertText = `${(e.data && e.data.error && e.data.error.desc) || e.toString()}`;
        this.showalertInfo = true;
      }
      if (data.code === 200) {
        if (data.status === 'error') {
          setTimeout(() => {
            this.btnIsChenked = true;
          }, 1000);
          if (data.error.code === 1006) {
            this.showalertText = this.iarTrans('feedBack.errorCaptcha');
          } else {
            this.showalertText = `${data.error.desc}`;
          }
          this.showalertInfo = true;
          this.onGetcode();
        } else {
          this.onSubmitSuccess();
        }
      } else {
        this.btnIsChenked = true;
        this.showalertText = `${data.error.desc}`;
        this.showalertInfo = true;
      }
    },
    async onGetcode() {
      const obj = await this.feedBackSdk?.getcode();
      if (obj.data) {
        this.captchaObj = obj.data;
      }
    },
    handleToastHidden() {
      this.showalertInfo = false;
    },
    // 提交成功
    onSubmitSuccess() {
      this.btnIsChenked = true;
      this.$emit('to-hide');
      this.showSubmitTips({
        tipsClass: this.tipsClass,
        mountNode: this.mountNode,
        tips: this.iarTrans('feedBack.submitSuccess')
      });
      this.$nextTick(() => {
        this.resetFrom();
      });
    },
    // 处理反馈提交消息
    onSubmit() {
      this.$emit('to-hide');
    },

  },
};
